import { maybe } from '@passionware/monads';
import { z } from 'zod';

export const globalSearch$ = z
  .array(
    z.object({
      id: z.number(),
      name: z.string(),
      description: z
        .string()
        .nullish()
        .transform(maybe.getOrUndefined)
        .optional(),
      url: z.string(),
      badge: z
        .object({
          text: z.string(),
          color: z.string().nullish().transform(maybe.getOrUndefined).optional()
        })
        .nullish()
        .transform(maybe.getOrUndefined)
        .optional(),
      avatar: z
        .object({
          url: z.string().nullish().transform(maybe.getOrUndefined).optional(),
          fallback: z
            .string()
            .nullish()
            .transform(maybe.getOrUndefined)
            .optional(),
          ascii: z.string().nullish().transform(maybe.getOrUndefined).optional()
        })
        .nullish()
        .transform(maybe.getOrUndefined)
        .optional(),
      group: z.string().nullish().transform(maybe.getOrUndefined).optional(),
      shortcut: z.string().nullish().transform(maybe.getOrUndefined).optional()
    })
  )
  .catch(e => {
    console.warn('Error parsing globalSearch$', e);
    return [];
  });
